var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5016 10.0218H12.0562H12.5016H13.0562H14.7713L14.7027 10.1813C14.3908 10.9067 13.6803 12.3484 12.5534 13.7297L12.275 14.071L11.9967 13.7297C10.8715 12.3505 10.1679 10.9097 9.84407 10.1736L9.77725 10.0218H11.5016Z",
    stroke: "#575655",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8966 10.5764H10.6553C11.0051 11.276 11.5414 12.2398 12.2798 13.1804C13.0105 12.2398 13.5546 11.276 13.8966 10.5764Z",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7471 31.2172H31.7191L29.7292 26.4757L27.7471 31.2172Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6817 18.4582H21.7858C19.9514 18.4582 18.459 19.9428 18.459 21.7773V37.6809C18.459 39.5076 19.9514 41 21.7858 41H37.6817C39.5161 41 41.0008 39.5076 41.0008 37.6809V21.7773C41.0008 19.9428 39.5161 18.4582 37.6817 18.4582ZM34.5803 35.8776C34.1838 36.0408 33.733 35.862 33.562 35.4656L32.3727 32.6051H27.0948L25.9056 35.4656C25.7812 35.761 25.4936 35.9397 25.1904 35.9397C25.0894 35.9397 24.9883 35.9164 24.8873 35.8776C24.4909 35.7143 24.3043 35.2557 24.4675 34.8593L25.8667 31.5247L29.0148 23.9926C29.1391 23.705 29.419 23.5184 29.7299 23.5184C30.0486 23.5184 30.3284 23.705 30.4528 23.9926L35 34.8593C35.1632 35.2557 34.9767 35.7143 34.5803 35.8776Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 18.5V12.25V5C23.5 2.79086 21.7091 1 19.5 1H5C2.79086 1 1 2.79086 1 5V19.5C1 21.7091 2.79086 23.5 5 23.5H12.25H18.5",
    stroke: "#575655",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.5184fd3530989ba4d4df69ef5e6d3dd2.svg";
export { ForwardRef as ReactComponent };